import { TenantOrderLine } from '~/lib/model';
import Big from 'big.js';
import { FIRST_VERSION_TIMESTAMP, ZodVersionedMetadata } from '~/lib/zod';
import { DeliverableType } from '~common/model/Deliverable';
import { PersonaType } from '~/tenants/common/TenantPersona';
import Mlm3dConfig from '~/tenants/mlm/performable/3d/Mlm3dConfig';
import MlmJob from '~/tenants/mlm/model/MlmJob';

export default class Mlm3dJob extends MlmJob<typeof Mlm3dConfig> {
  defaultValue(): ZodVersionedMetadata<(typeof Mlm3dConfig)['schema']> {
    return {
      version: FIRST_VERSION_TIMESTAMP
    };
  }

  onsite() {
    if (this.order.metadata.sqft > 7000) {
      return 180;
    }

    if (this.order.metadata.sqft > 5000) {
      return 120;
    }

    if (this.order.metadata.sqft > 3000) {
      return 90;
    }

    return 60;
  }

  get submitter() {
    return PersonaType.OFFICE;
  }

  get deliverable() {
    return DeliverableType.IGUIDE;
  }

  get performable() {
    return Mlm3dConfig;
  }

  revenueLines(): TenantOrderLine[] {
    const lines = super.revenueLines();

    lines.push({
      amount: new Big(275),
      description: '3D iGuide',
      id: '3d',
    });

    return lines;
  }
}
